import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row } from "react-bootstrap";
import { SearchIcon } from '@primer/octicons-react'
import LocPickerDialog from './LocPickerDialog';
import { axiosAuth_LEASE_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { isNaturalNumber } from '../utils/jsUtils';


const FloorAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [floorAttrs, setFloorAttrs] = useState({
    id: '',
    name: '',
    nameLang2: '',
    nameLang3: '',
    description: '',
    type: 'RESERVED',
/*
    grossFloorArea: '',
    saleableFloorArea: '',
    sortSequenceNum: '',
*/
    floorLocCode: '',
    floorLocId: ''
/*
    status: ''
*/
  });

  const statusOptions = [
    { key: "VACANT", value: "VACANT" },
    { key: "LEASED", value: "LEASED" }
  ];

  const [showLocPickerDialog, setShowLocPickerDialog] = useState(false);


  // Initialize state
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  // UI Functions

  // Location select dialog stuff

  const handleLocPicker = (e) => {
    setShowLocPickerDialog(true);
  }

  function handleLocPickerClose() {
    setShowLocPickerDialog(false);
  }

  function handleLocSelect(location) {
/* ##### If I do this, the locationId is NOT set.  Why??? #####
    setFloorAttrs({ ...floorAttrs, locationId: location.id });
    setFloorAttrs({ ...floorAttrs, location:   location.code });
*/
    // Deep copy
    let newFloorAttr = JSON.parse (JSON.stringify(floorAttrs));
    newFloorAttr.floorLocId   = location.id;
    newFloorAttr.floorLocCode = location.code;

    setFloorAttrs(newFloorAttr);

    setShowLocPickerDialog(false);
  }


  // General stuff
  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setFloorAttrs({ ...floorAttrs, [e.target.name]: e.target.value })
  }

  const onStatusSelect = (key, event) => {
    setFloorAttrs({ ...floorAttrs, status: key })
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!floorAttrs.name || floorAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_LEASE_MGMT_API.get("prop-floors?name=" + floorAttrs.name);

        resolve(res.data);

        if (res.data.length > 0) {
          setErrMsg(t("I18N_ERR_Dup_name"));
        } else {
          validateOtherFields();
        }

        return;

      } catch (error) {

        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }

        return;
      }
    });
  }

  function validateOtherFields() {

    // Validate form inputs
    if ((floorAttrs.name != null) && (floorAttrs.name.length > 100)) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 100);
    } else if ((floorAttrs.nameLang2 != null) && (floorAttrs.nameLang2.length > 100)) {
      setErrMsg(t("I18N_ERR_Max_len_name_no_col") + " (" + t("custom:I18N_Language_2") + "): " + 100);
    } else if ((floorAttrs.nameLang3 != null) && (floorAttrs.nameLang3.length > 100)) {
      setErrMsg(t("I18N_ERR_Max_len_name_no_col") + " (" + t("custom:I18N_Language_3") + "): " + 100);
    } else if (!floorAttrs.description || floorAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if ((floorAttrs.description != null) && (floorAttrs.description.length > 200)) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
    } else if (floorAttrs.floorLocCode.length === 0) {
      setErrMsg(t("I18N_ERR_Need_floor_loc"));
/*
    } else if (floorAttrs.type === '') {
      setErrMsg(t("I18N_ERR_Need_type"));
    } else if ((floorAttrs.type != null) && (floorAttrs.type.length > 20)) {
      setErrMsg(t("I18N_ERR_Max_len_type") + 20);
*/
    } else if (floorAttrs.grossFloorArea && !isNaturalNumber(floorAttrs.grossFloorArea)) {
      setErrMsg(t("I18N_ERR_Validate_GFA"));
      return;
    } else if (floorAttrs.saleableFloorArea && !isNaturalNumber(floorAttrs.saleableFloorArea)) {
      setErrMsg(t("I18N_ERR_Validate_SFA"));
      return;
    } else if (floorAttrs.sortSequenceNum && !isNaturalNumber(floorAttrs.sortSequenceNum)) {
      setErrMsg(t("I18N_ERR_Validate_Sort_seq_num"));
      return;
    } else if (!floorAttrs.status || floorAttrs.status.length === 0) {
      setErrMsg(t("I18N_ERR_Need_status"));
    } else {
      setErrMsg('');
      createNewFloor();
    }
  }

  const createNewFloor = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(floorAttrs));

    // Convert integer types
    reqBody.grossFloorArea    = floorAttrs.grossFloorArea    ? floorAttrs.grossFloorArea    : null;
    reqBody.saleableFloorArea = floorAttrs.saleableFloorArea ? floorAttrs.saleableFloorArea : null;
    reqBody.sortSequenceNum   = floorAttrs.sortSequenceNum   ? floorAttrs.sortSequenceNum   : null;

    // Pre-processing
    reqBody.nameLang2 = floorAttrs.nameLang2 && (floorAttrs.nameLang2.trim().length > 0) ? floorAttrs.nameLang2 : null;
    reqBody.nameLang3 = floorAttrs.nameLang3 && (floorAttrs.nameLang3.trim().length > 0) ? floorAttrs.nameLang3 : null;

    // Note: reqBody.location is actually not used by the API
    if (reqBody.location === '') {
      reqBody.locationId = '';
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_LEASE_MGMT_API.post("prop-floors", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', height:'600px', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Prop_Floor")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Prop_floor_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_Name")}: *</Col>
              <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}:</Col>
              <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}:</Col>
              <Col>{t("I18N_Description")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={floorAttrs.name}
                          onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="nameLang2" value={floorAttrs.nameLang2}
                          onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="nameLang3" value={floorAttrs.nameLang3}
                          onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description" value={floorAttrs.description}
                          onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Fl_loc_code")}: *</Col>
              <Col>{t("I18N_GFA")}:</Col>
              <Col>{t("I18N_SFA")}:</Col>
              <Col>{t("I18N_Sort_seq_num")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input readOnly className={classes.admin_pages__field_editable} style={{width:'80%'}} name="location" value={floorAttrs.floorLocCode}
                  onChange={(e) => onAttrsInputChange(e)} />
                <span onClick={handleLocPicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <SearchIcon size={14} />
                </span>
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="grossFloorArea" value={floorAttrs.grossFloorArea}
                       onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="saleableFloorArea" value={floorAttrs.saleableFloorArea}
                       onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="sortSequenceNum" value={floorAttrs.sortSequenceNum}
                       onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Status")}: *</Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={ !floorAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + floorAttrs.status) }
                  onSelect={onStatusSelect}>
                  {statusOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>


            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>


        <LocPickerDialog
          show={showLocPickerDialog}
          handleObjSelect={handleLocSelect}
          onClose={handleLocPickerClose}
          type='FLOOR'
        />

      </Card>
    </>
  );
}

export default FloorAdminNewView;
